import React from "react";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { Link } from "react-router-dom";
import { USERS_ACTIONS } from "../../../redux/users/actions";
import { connect } from "react-redux";
import { selectUsers, usersMeta } from "../../../redux/users/selectors";
import PropTypes from "prop-types";
import Confirm from "../../../base/Confirm";
import { baseValue, dateRender } from "../../../libs/utils";
import ListView from "../../../base/ListView";
import { getCompanies } from "../../../services/api/companies";
import { toImmutable } from "../../../libs/immutable-transformer";
import queryString from "query-string";

class _Employees extends React.Component {
  constructor(props) {
    super(props);

    const parsedFilters = queryString.parse(window.location.search);
    const baseFilters = {
      "page[number]": 1,
      "page[size]": 10,
      sort: "-updated_at",
      include: "companies",
      "filter[crew_admin]": "",
      "filter[gatekeeping_admin]": "",
      "filter[material_admin]": "",
      ...parsedFilters
    };

    this.state = {
      users: this.props.users,
      baseFilters: toImmutable(baseFilters)
    };

    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    loadUsers: PropTypes.func,
    users: PropTypes.array,
    deleteUser: PropTypes.func,
    usersMeta: PropTypes.object,
    updateFilters: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.updateFilters(this.state.baseFilters);
    this.props.loadUsers();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      users: nextProps.users
    });
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleDelete(id) {
    Confirm("Are you sure you want to delete this User?", {
      title: "Delete User",
      confirmStyle: "btn-danger",
      confirmText: "Delete"
    }).then(
      result => {
        this.props.deleteUser(id);
      },
      result => {}
    );
  }

  render() {
    const { users, baseFilters } = this.state;
    const { usersMeta } = this.props;

    const listViewConf = {
      dataSet: users,
      dataMeta: usersMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name",
          render: user => user.firstName + " " + baseValue(user.lastName)
        },
        {
          key: "company",
          value: "Company",
          render: user => {
            if (user.companies) {
              return user.companies.map(company => (
                <div key={company.id}>
                  <span style={{ marginRight: "10px" }}>{company.name}</span>
                  {company.crewAdmin === 1 && (
                    <span data-tip="Crew Admin" className="la la-user" />
                  )}
                  {company.gatekeepingAdmin === 1 && (
                    <span
                      data-tip="Gatekeeping Admin"
                      className="la la-truck"
                    />
                  )}
                  {company.materialAdmin === 1 && (
                    <span data-tip="Material Admin" className="la la-wrench" />
                  )}
                </div>
              ));
            }
            return "";
          }
        },
        {
          key: "updatedAt",
          value: "Last Updated",
          sort: "updated_at",
          render: user => dateRender(user.updatedAt)
        }
      ],
      baseFilters: baseFilters,
      filters: [
        {
          col: "4",
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        },
        {
          col: "4",
          label: "Email",
          icon: "la-search",
          type: "text",
          key: "email"
        },
        {
          col: "4",
          label: "Company",
          icon: "la-map-marker",
          type: "typeahead",
          options: value =>
            getCompanies({
              "filter[name]": value
            }),
          key: "company_id",
          labelKey: "name"
        },
        {
          col: "4",
          label: "Crew Admin",
          type: "checkbox",
          key: "crew_admin",
          value: 1
        },
        {
          col: "4",
          label: "Gatekeeping Admin",
          type: "checkbox",
          key: "gatekeeping_admin",
          value: 1
        },
        {
          col: "4",
          label: "Material Admin",
          type: "checkbox",
          key: "material_admin",
          value: 1
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "employees"
    };

    return [
      <AdminSubHeader title="Employees" key="subheader" breadcrumbs={[]}>
        <Link
          to="/admin/employees/create"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-plus" />
        </Link>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <ListView
              config={listViewConf}
              handleDelete={this._handleDelete}
              handleFilterUpdate={this._handleFilterUpdate}
            />
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadUsers: params => dispatch(USERS_ACTIONS.loadAllRequest(params)),
  deleteUser: id => dispatch(USERS_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(USERS_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    users: selectUsers(state),
    usersMeta: usersMeta(state)
  };
};

const Employees = connect(mapStateToProps, mapDispatchToProps)(_Employees);

export default Employees;
